import React from 'react'
import { Helmet } from "react-helmet";
import { useNavigate,useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import useTranslations from 'i18n/useTranslations';

const VerifiedComplete = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const qPage = searchParams.get("page")
    const qRestaurantId = searchParams.get("restaurantId")
    const { status } = location.state || {};
    const { t } = useTranslations();
    const navigate = useNavigate();
    const handleOnclick = () =>{
        if (qPage) {
            const redirectPage =`/${qPage}?restaurantId=${qRestaurantId}`
            navigate(redirectPage)
        } else {
            navigate('/profile')
        }
    }
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageVerified-complete">
                <main id="top">
                    <div className="wrapContent">
                        <section id="pComplete">

                            <div className="bComplete">
                                <div className="bLogo">
                                    <img src="assets/img/ci/complete/logo-welcome.svg" alt="" />
                                </div>
                                <div className="bText">
                                    <img src="assets/img/ci/complete/ico-complete.svg" alt="" />
                                    <h1>{t.verifiedComplete.body}</h1>
                                    {status == 0 ?
                                    <p>{t.registerComplete.body1}</p>
                                    :''}
                                </div>
                                <div className="bBtn">
                                    <a className="btn white" onClick={handleOnclick}>{t.verifiedComplete.start}</a>
                                </div>
                            </div>

                        </section>
                    </div>
                </main>

            </div>
        </div>
    )
}

export default VerifiedComplete